import { render, staticRenderFns } from "./toLoginPage.vue?vue&type=template&id=40be5ef2&scoped=true"
import script from "./toLoginPage.vue?vue&type=script&lang=js"
export * from "./toLoginPage.vue?vue&type=script&lang=js"
import style0 from "./toLoginPage.vue?vue&type=style&index=0&id=40be5ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40be5ef2",
  null
  
)

export default component.exports